import { Web3Provider } from '@ethersproject/providers'
import { InjectedConnector } from './InjectedConnector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { WalletLinkConnector } from '@web3-react/walletlink-connector'
import { PortisConnector } from '@web3-react/portis-connector'

import { FortmaticConnector } from './Fortmatic'
import { NetworkConnector } from './NetworkConnector'
import { ChainId } from '@uniswap/sdk'

const NETWORK_URL = process.env.REACT_APP_NETWORK_URL
const FORMATIC_KEY = process.env.REACT_APP_FORTMATIC_KEY
const PORTIS_ID = process.env.REACT_APP_PORTIS_ID

export const NETWORK_CHAIN_ID: number = Number(process.env.REACT_APP_CHAIN_ID) // 默认使用 K 链

if (typeof NETWORK_URL === 'undefined') {
  throw new Error(`REACT_APP_NETWORK_URL must be a defined environment variable`)
}

// 支持的网络配置
const SUPPORTED_NETWORKS = {
  [ChainId.K]: NETWORK_URL,
  [ChainId.BSC]: process.env.REACT_APP_BSC_RPC_URL || 'https://bscrpc.pancakeswap.finance'
}

export const network = new NetworkConnector({
  urls: SUPPORTED_NETWORKS,
  defaultChainId: NETWORK_CHAIN_ID // 明确指定默认链 ID
})

let networkLibrary: Web3Provider | undefined
export function getNetworkLibrary(): Web3Provider {
  return (networkLibrary = networkLibrary ?? new Web3Provider(network.provider as any))
}

export const injected = new InjectedConnector({
  supportedChainIds: [ChainId.K, ChainId.BSC]
})

// WalletConnect只支持单个chainId，使用默认的K链
export const walletconnect = new WalletConnectConnector({
  rpc: { [NETWORK_CHAIN_ID]: NETWORK_URL },
  bridge: 'https://bridge.walletconnect.org',
  qrcode: true,
  pollingInterval: 15000
})

export const walletlink = new WalletLinkConnector({
  url: NETWORK_URL,
  appName: 'KingSwap'
})

// Fortmatic不支持K链，使用MAINNET作为fallback
export const fortmatic = new FortmaticConnector({
  apiKey: FORMATIC_KEY ?? '',
  chainId: ChainId.MAINNET // 使用MAINNET作为默认值
})

// Portis不支持K链，使用MAINNET作为fallback
export const portis = new PortisConnector({
  dAppId: PORTIS_ID ?? '',
  networks: [ChainId.MAINNET] // 使用MAINNET作为默认值
})
